import { Navigate } from 'react-router-dom'

import { getLocalStorage } from '../helpers'
import routes from './routes.constants'

const AuthRoute = ({ children }) => {
  const context = getLocalStorage('context')
  if (context?.finished || !context?.orderInfo?.id) return <Navigate to={routes.notFoundPage} />

  return children
}

export default AuthRoute
